<div>

    <div class="flex flex-col">
        <span class="font-semibold text-2xl py-2">
            Actualizar Colección
        </span>
   </div>

    <form #myForm="ngForm" class="flex flex-col w-full">
       <mat-form-field class="fuse-mat-dense">
            <mat-label>Coleccion</mat-label>
            <mat-select [(ngModel)]="cambioColeccion.nuevaColeccion" id="coleccion" name="coleccion">
                @for (c of colecciones; track c) {
                    <mat-option [value]="c">{{c.descripcion}}</mat-option>
                }
            </mat-select>
        </mat-form-field> 

        <buscador-gestiones
            [tiposGestionesBienesCulturales]="listaGestiones"
            (gestionesSeleccionadasChange)="gestionesSeleccionadasPadre = $event"
            ></buscador-gestiones>

        <mat-checkbox 
            class="mt-4"
            name="cambioNoRegistro" id="cambioNoRegistro"
                [(ngModel)]="cambioColeccion.cambioNoRegistro">
            ¿Desea cambiar el número de registro del bien cultural?
        </mat-checkbox>
    </form>


    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-raised-button
            class="rounded-sm w-full"  
            [color]="'secondary'"
            (click)="this.dialogRef.close(false)">
            Cancelar
        </button>

        <button mat-raised-button 
            [color]="'primary'" 
            class="rounded-sm w-full"
            type="submit"
            (click)="actualizarColeccion()"
            [disabled]="!myForm.valid || gestionesSeleccionadasPadre.length === 0"
            >Actualizar
        </button>
    </div>
</div>